import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  Flex,
  Image,
  Text,
  useDisclosure,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  Step,
  StepIcon,
  StepIndicator,
  StepNumber,
  Stepper,
  StepSeparator,
  StepStatus,
  StepTitle,
  Table,
  TableContainer,
  Tbody,
  Td,
  Thead,
  Tr,
  // useDisclosure,
} from "@chakra-ui/react";
import TableLocking from "./tableLocking";
import IconFile from "../../assets/images/booking/upfile.svg";
import iconPlus from "../../assets/images/booking/plus.svg";
import PopupImport from "../../components/popup/PopupImport";
// import FormDetail from "./form/detail";
import { commonCall } from "../../api/common";
import toast from "react-hot-toast";
import { lockingCall } from "../../api/locking";
import { lockingImageCall } from "../../api/lockingImage";
import { lockingParticipantCall } from "../../api/lockingParticipant";
import { exportFile } from "../../utils/tools";
import { formatDateToLocal } from "../../utils/utils";
import { useLocking } from "../../hooks/useLooking";
import { useNavigate, useLocation, useParams } from "react-router-dom";
import { lockingRelativeParticipantCall } from "../../api/lockingRelativeParticipant";
import { formatTableValue } from "./formatTable";
import iconApproved from "../../assets/images/receiveSalary/check-circle.svg";
import ServiceFeeManagementStep1Detail from "./step1Detail";
import ServiceFeeManagementStep2Detail from "./step2Detail";
import ServiceFeeManagementStep3Detail from "./step3Detail";
import { useIsInViewport } from "../../hooks/useIsInViewpost";

export default function ServiceFeeManagementStep1() {
  const location = useLocation();
  const { lockingId } = useParams();
  const [locking, setLocking] = useState(null);
  const [lockingRelativeParticipant, setRelativeParticipant] = useState([]);

  const getLocking = async (lockingId) => {
    const locking = await lockingCall.get(lockingId);

    if (locking) {
      setLocking(locking);
    }
  };

  const getLockingRelativeParticipant = async (lockingId) => {
    const participants =
      await lockingRelativeParticipantCall.getByLockingId(lockingId);

    if (participants) {
      setRelativeParticipant(participants);
    }
  };

  useEffect(() => {
    if (lockingId) {
      getLocking(lockingId);
      getLockingRelativeParticipant(lockingId);
    }
  }, [lockingId]);

  const steps = [
    { title: "Duyệt nhân viên tham gia giao dịch" },
    { title: "Duyệt thông tin giao dịch" },
    { title: "Xác nhận phí dịch vụ" },
  ];

  const [activeStep, setActiveStep] = useState(1);
  const handleNext = (step) => {
    if (step) {
      setActiveStep(step);
    }
    if (activeStep < steps.length) {
      setActiveStep((prevStep) => prevStep + 1);
    }
  };

  const handlePrevious = (step) => {
    if (activeStep > 0) {
      setActiveStep(step);
    }
  };

  useEffect(() => {
    if (locking) {
      setActiveStep(
        locking?.status === "APPROVED" &&
          locking?.registerRelativeStatus === "APPROVED" &&
          locking?.confirmInformationStatus !== "APPROVED"
          ? 2
          : locking?.status === "APPROVED" &&
              locking?.registerRelativeStatus === "APPROVED" &&
              locking?.confirmInformationStatus === "APPROVED"
            ? 3
            : 1,
      );
    }
  }, [locking?._id]);

  const dataSteps = [
    {
      step: 1,
      data: (
        <ServiceFeeManagementStep1Detail
          lockingId={lockingId}
          locking={locking}
          setLocking={setLocking}
          getLocking={getLocking}
          handleNext={handleNext}
          handlePrevious={handlePrevious}
        />
      ),
    },
    {
      step: 2,
      data: (
        <ServiceFeeManagementStep2Detail
          lockingId={lockingId}
          locking={locking}
          setLocking={setLocking}
          getLocking={getLocking}
          handleNext={handleNext}
          handlePrevious={handlePrevious}
        />
      ),
    },
    {
      step: 3,
      data: (
        <ServiceFeeManagementStep3Detail
          lockingId={lockingId}
          locking={locking}
          setLocking={setLocking}
          getLocking={getLocking}
          handleNext={handleNext}
          handlePrevious={handlePrevious}
        />
      ),
    },
  ];

  return (
    <Box
      w={{ base: "100%" }}
      backgroundColor="var(--color-backgroundmain)"
      p={{ base: "24px 16px 16px" }}
    >
      <Flex alignItems={"center"} justifyContent={"space-between"}>
        <Flex alignItems={"center"} gap={{ base: "74px" }}>
          <Text fontSize={{ base: "20px" }} fontWeight={600}>
            Quản lý phí dịch vụ
          </Text>
        </Flex>
        <Flex alignItems={"center"} gap={"16px"}></Flex>
      </Flex>
      <Box mt={{ base: "25px" }} borderRadius={"16px"} bg={"white"}>
        <Box
          paddingTop={"40px"}
          paddingBottom={"24px"}
          position={"relative"}
          borderBottom={"1px solid var(--border-input-employee)"}
        >
          <Box padding={"0px 24px"}>
            <Stepper w={"full"} index={activeStep - 1} count={steps.length}>
              {steps.map((step, index) => {
                return (
                  <Step key={index}>
                    <StepIndicator
                      fontSize={"16px"}
                      fontWeight={600}
                      color={"red"}
                      sx={{
                        bg: `${
                          locking?.confirmInformationStatus === "APPROVED"
                            ? index === 0 || index === 1
                              ? "var(--color-status-employ)"
                              : "var(--color-option-employee-hover)"
                            : locking?.registerRelativeStatus === "APPROVED"
                              ? index === 0
                                ? "var(--color-status-employ)"
                                : index === 2
                                  ? "var(--color-black-3)"
                                  : "var(--color-option-employee-hover)"
                              : activeStep >= index + 1
                                ? activeStep > index + 1
                                  ? "var(--color-status-employ)"
                                  : "var(--color-option-employee-hover)"
                                : "var(--color-black-3)"
                        } !important`,
                      }}
                      border={"none"}
                      outline={"none"}
                      w={"28px"}
                      h={"28px"}
                    >
                      <StepStatus
                        complete={<StepIcon />}
                        incomplete={<StepNumber color={"var(--color-main)"} />}
                        active={<StepNumber color={"var(--color-main)"} />}
                      />
                    </StepIndicator>

                    <Box flexShrink="0">
                      <StepTitle
                        sx={{
                          color: `${
                            locking?.registerRelativeStatus === "APPROVED" ||
                            locking?.confirmInformationStatus === "APPROVED"
                              ? index === activeStep - 1
                                ? "var(--color-option-employee-hover)"
                                : "var(--color-info-employee)"
                              : activeStep >= index + 1
                                ? activeStep > index + 1
                                  ? "var(--color-status-employ)"
                                  : "var(--color-info-employee)"
                                : "var(--color-info-employee)"
                          } !important`,
                        }}
                        onClick={() => {
                          // console.log({index})
                          // console.log({activeStep})
                          if (index === 0) {
                            handlePrevious(index + 1);
                          } else if (index === 1) {
                            if (
                              locking?.registerRelativeStatus === "APPROVED"
                            ) {
                              if (activeStep === 3) {
                                handleNext(index + 1);
                              } else {
                                handleNext(index);
                              }
                            } else if (
                              locking?.confirmInformationStatus === "APPROVED"
                            ) {
                              handleNext(index);
                            }
                          } else if (index === 2) {
                            if (
                              locking?.confirmInformationStatus ===
                                "APPROVED" &&
                              activeStep < 3
                            ) {
                              handleNext(index);
                            }
                          }
                        }}
                        cursor={
                          locking?.confirmInformationStatus === "APPROVED"
                            ? "pointer"
                            : locking?.registerRelativeStatus === "APPROVED"
                              ? index === 0 || index === 1
                                ? "pointer"
                                : "inherit"
                              : index === 0
                                ? "pointer"
                                : "inherit"
                        }
                      >
                        {step.title}
                      </StepTitle>
                    </Box>

                    <StepSeparator
                      sx={{
                        bg: `var(--color-black-2) !important`,
                      }}
                    />
                  </Step>
                );
              })}
            </Stepper>
          </Box>
        </Box>

        <Box padding={"25px 24px"}>{dataSteps[activeStep - 1]?.data}</Box>
      </Box>
    </Box>
  );
}
